"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var formik_1 = require("formik");
var react_1 = __importDefault(require("react"));
var Button_1 = __importDefault(require("../../../../../../basics/Button"));
var SubmitButton = function (_a) {
    var children = _a.children;
    var formik = formik_1.useFormikContext();
    return (react_1.default.createElement(Button_1.default, { type: "submit", disabled: formik.isSubmitting }, formik.isSubmitting ? 'Loading...' : children));
};
exports.default = SubmitButton;
